export default __webpack_public_path__ + "static/header_image_one-e9b03b674b75d3f090433d158180b82a.jpg";